module.exports = __webpack_public_path__ + "img/6n.9e1b3258.png";